<template>
  <div class="p-12">
    <BaseFormSelect
      v-if="facebookPageOptions.length > 1"
      v-model="selectedFacebookPageId"
      :options="facebookPageOptions"
    />
    <div v-if="selectedFacebookPageId" class="mt-6">
      <FacebookPageInsights
        :key="selectedFacebookPageId"
        :facebook-page-id="selectedFacebookPageId"
        :account-id="accountId"
      />
    </div>
  </div>
</template>

<script>
import FacebookPageInsights from './facebook/components/facebook-page-insights.vue';

export default {
  components: {
    FacebookPageInsights,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedFacebookPageId: null,
    };
  },
  computed: {
    facebookPageIds() {
      return this.$store.getters['ui/accountFacebookPages/idsByParent'](this.accountId);
    },
    facebookPageOptions() {
      return this.facebookPageIds
        .map((facebookPageId) => this.$store.state.entities.facebookPages.byId[facebookPageId])
        .map((facebookPage) => ({ label: facebookPage.name, value: facebookPage.id }));
    },
  },
  created() {
    this.fetchAccountFacebookPages();
  },
  destroyed() {
    this.$store.dispatch('ui/accountFacebookPages/clearIds', this.accountId);
  },
  methods: {
    async fetchAccountFacebookPages() {
      try {
        await this.$store.dispatch('ui/accountFacebookPages/load', {
          parentId: this.accountId,
        });

        const [defaultFacebookPageId = null] = this.facebookPageIds;
        this.selectedFacebookPageId = defaultFacebookPageId;
      } catch (error) {
        // catch any server errors here
      }
    },
  },
};
</script>
